module.exports = "/fonts/fa-regular-400.eot?fc9c63c8224fb341fc933641cbdd12ef";